'use strict';

var notifyMeToastTimer;

/**
 * This method will handle toast message notifyme form submission response
 * @param {string} message  Contains the toast message to display in the storefront
 * @param {string} pid Id of the product
 */
function handleNotifyMeResponse(message, pid) {
    $('#notifymeModal').modal('hide');
    $('.notify-me-button[data-pid="'+ pid +'"]').addClass('d-none').next().removeClass('d-none');

    if ($('.notifyme-toast').length === 0) {
        $('body').append(
            '<div class="notifyme-toast"></div>'
        );
    }

    if (notifyMeToastTimer) clearTimeout(notifyMeToastTimer);

    $('.notifyme-toast').empty().append(message).fadeIn();

    notifyMeToastTimer = setTimeout(function () {
        $('.notifyme-toast').fadeOut();
    }, 5000);
}

module.exports = {

    /**
     * In PLP, fetch pid from product tile and update it in notify me form
     */
    handleNotifyMeModal: function () {
        $(document).on('click', '.notify-me-button', function(e) {
            $('#notifymeModal .modal-content').addClass('d-none');
            e.preventDefault();
            var notifyMe = $(this);
            var url = notifyMe.data('notifymeurl');
            var pid = notifyMe.data('pid');
            var pageType = notifyMe.data('pagetype');
            url += '?pid=' + pid;
            if (pageType !== undefined && pageType !== null) {
                url += '&pageType=' + pageType;
            }
            $.ajax({
                url: url,
                method: 'GET',
                success: function (response) {
                    if(response){        
                        $('.notifyme-modal-content').empty().html(response);
                        $('#notifymeModal .modal-content').removeClass('d-none');
                    }
                }
            });
        });
    },

    /**
     * Handle submit of register warranty form
     */
    submitform: function () {
        // Remove any existing handlers to prevent duplicate registrations
        $(document).off('submit', 'form.notifyme-form');
        $(document).on('submit', 'form.notifyme-form', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (window.isSubmittingNotify) return;
            window.isSubmittingNotify = true;
            $('.notify-me-btn').attr('disabled', true);
            var notifyMeForm = $(this);
            var pid = $('.notify-me-btn').data('pid');
            var productName = $('.notify-me-btn').data('productname');
            var comingSoon = $('.notify-me-btn').data('comingsoon');
            var comingSoonMsg = $('.notify-me-btn').data('coming-soon-message');
            var sucessMsg = $('.notify-me-btn').data('message');
            var url = $('.notify-me-btn').data('href');
            if (comingSoon && comingSoon === true) {
                sucessMsg = comingSoonMsg;
            }
            var email = notifyMeForm.find('#notify-form-email').val();
            var phone = notifyMeForm.find('#notify-form-phone').val();
            var mcaPLPPDPSignUpEnable = notifyMeForm.find('#mcaPLPPDPSignUpEnable').val();
            var mcaEnabled = notifyMeForm.find('#mcaEnabled').val();
            if (mcaEnabled && mcaEnabled === 'true' && mcaPLPPDPSignUpEnable && mcaPLPPDPSignUpEnable === 'true') {
                // Serialize form fields to object
                const formArray = notifyMeForm.serializeArray();
                const formDataObj = {};
                formArray.forEach(function (item) {
                    formDataObj[item.name] = item.value;
                });
                formDataObj.emailId = email;
                formDataObj.phone = phone;
                formDataObj.pid = pid;
                formDataObj.isbackinstock = true;
                $.ajax({
                    url: url,
                    type: 'post',
                    data: formDataObj,
                    success: function (response) {
                        window.isSubmittingNotify = false;
                        $('.notify-me-btn').attr('disabled', false);
                        if (response && response.success) {
                            handleNotifyMeResponse(sucessMsg, pid);
                        }
                    },
                    error: function (err) {
                        window.isSubmittingNotify = false;
                        $('.notify-me-btn').attr('disabled', false);
                        console.error('Error submitting customer form:', err);
                    }
                });
            // eslint-disable-next-line no-undef
            } else if (mcaPLPPDPSignUpEnable && mcaPLPPDPSignUpEnable === 'false' && typeof _ltk === 'object' && typeof _ltk.Alerts === 'object') {
                if (phone !== undefined){
                    // eslint-disable-next-line no-undef
                    _ltk.Alerts.AddAlertWithIdentifiers({Identifiers:{Email:email,PhoneNumber:phone}, Sku:pid, AlertCode:'Back-in-Stock'});
                } else {
                    // eslint-disable-next-line no-undef
                    _ltk.Alerts.AddAlertWithIdentifiers({Identifiers:{Email:email}, Sku:pid, AlertCode:'Back-in-Stock'});

                }
                // eslint-disable-next-line no-undef
                _ltk.Alerts.Submit();
                window.isSubmittingNotify = false;
                $('.notify-me-btn').attr('disabled', false);
                handleNotifyMeResponse(sucessMsg, pid);
            } 
            else {
                // Call NotifyMe route for bloomreach
                var formData = notifyMeForm.serialize();
                formData = formData + '&pid=' + pid;
                var actionUrl = notifyMeForm.attr('action');
                var enableBloomreach = notifyMeForm.find('#enableBloomreach').val();

                if (enableBloomreach){
                    $.ajax({
                        url: actionUrl,
                        method: 'POST',
                        data: formData,
                        dataType: 'json',
                        success: function (response) {
                            window.isSubmittingNotify = false;
                            $('.notify-me-btn').attr('disabled', false);
                            if (response && response.success) {
                                handleNotifyMeResponse(sucessMsg, pid)
                            }
                        },
                        error: function (error) {
                            window.isSubmittingNotify = false;
                            $('.notify-me-btn').attr('disabled', false);
                            console.error(error);
                        }
                    });
                } else {
                    window.isSubmittingNotify = false;
                    $('.notify-me-btn').attr('disabled', false);
                }
            }
            
            /* eslint-enable no-undef */
            window.gtmTagManager.gtmNotifyMeData(pid, productName);
        })
    },

    validateForm: function() {
        $(document).on('input', '.notifyme-form input, #agree-condition', function () {
            const $email = $('#notify-form-email');
            const emailVal = $email.val();
            const pattern = new RegExp($email.attr('pattern'));
            const $error = $('#form-email-error');
            const $btn = $('.notify-me-btn');
            const $phone = $('#notify-form-phone');

            let emailFilled = !!emailVal;
            let emailValid = emailFilled && pattern.test(emailVal);

            let phoneFilled = $phone.length && !!$phone.val();
            let phoneValid = phoneFilled && $phone[0].validity.valid;

            // show error only if email filled but invalid
            if (emailFilled && !emailValid) {
                $error.text($email.data('pattern-mismatch')).show();
            } else {
                $error.hide();
            }

            let enableBtn = false;

            if (emailFilled && phoneFilled) {
                enableBtn = emailValid && phoneValid;
            } else if (emailFilled) {
                enableBtn = emailValid;
            } else if (phoneFilled) {
                enableBtn = phoneValid;
            }

            $btn.attr('disabled', !enableBtn);
        });
    }
};